import {
  Autocomplete,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useSnackbar } from "notistack5";
import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  addPayMethodDataApi,
  updatePayMethodDataApi,
} from "src/Api/Services/SystemConfiguration";
import { paymentFieldData } from "./paymentFieldData";

const AddPaymentMethod = ({ data, fetchData, metaData, editData }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const formik = useFormik({
    initialValues: editData || {
      metaKey: "",
      upiDiscount: 0,
      creditCardDiscount: 0,
      debitCardDiscount: 0,
      netBankingDiscount: 0,
      payLaterDiscount: 0,
      walletDiscount: 0,
    },
    onSubmit: () => {
      handleSubmitApiCall();
    },
  });
  const {
    errors,
    touched,
    handleSubmit,
    isSubmitting,
    values,
    handleBlur,
    resetForm,
    setSubmitting,
    handleChange,
    setFieldValue,
  } = formik;

  const handleSubmitApiCall = async () => {
    try {
      const { data } = editData
        ? await updatePayMethodDataApi(values)
        : await addPayMethodDataApi(values);
      enqueueSnackbar(data.message, {
        variant: data.status ? "success" : "error",
      });
      if (data.status) {
        fetchData();
        resetForm();
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
    setSubmitting(false);
  };
  return (
    <form onSubmit={handleSubmit}>
      <Row>
        {paymentFieldData(values, metaData).map((item, index) => (
          <Col md={12} xs={12} xl={3} key={index}>
            {(item.type == "text" || item.type == "number") && (
              <TextField
                type={item.type}
                placeholder={item.placeHolder}
                size="normal"
                label={item.label}
                name={item.name}
                value={item.value}
                onChange={handleChange}
                error={errors[item.name] && touched[item.name]}
                fullWidth
                onBlur={handleBlur}
                className={index > 3 ? "mt-4" : ""}
              />
            )}
            {item.type == "autoSelect" && (
              <Autocomplete
                disablePortal
                options={item.options.map((option) => option.username) || []}
                value={item.value}
                name={item.name}
                onChange={(e, value) => setFieldValue(item.name, value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={item.label}
                    error={errors[item.name] && touched[item.name]}
                    onBlur={handleBlur}
                    placeholder={item.placeHolder}
                  />
                )}
              />
            )}
            {errors[item.name] && touched[item.name] && (
              <FormHelperText error id="component-error-text">
                {errors[item.name]}
              </FormHelperText>
            )}
          </Col>
        ))}
      </Row>
      <div className="text-center mt-4">
        <Button variant="contained" type="submit" disabled={isSubmitting}>
          Submit
        </Button>
      </div>
    </form>
  );
};
export default AddPaymentMethod;
